module.exports = __webpack_public_path__ + "static/img/in.b74ada10.png";